/**
 * Navigations-Labels der Admin-Sidebar (Namespace `nav`).
 * Ergänzt/überschreibt die in src/i18n/index.ts vorhandenen nav-Keys.
 */
export const nav = {
  de: {
    nav: {
      dashboard: 'Dashboard',
      calendar: 'Kalender',
      appointments: 'Termine',
      reminders: 'Erinnerungen',
      recalls: 'Recalls',
      patients: 'Patienten',
      intake: 'Erhebungsbögen',
      invoices: 'Belege',
      reports: 'Auswertungen',
      inbox: 'Posteingang',
      smartai: 'SmartAI',
      eventLog: 'Event Log',
      settings: 'Einstellungen',
      help: 'Hilfe',
      logout: 'Abmelden',
      openSidebar: 'Sidebar öffnen',
      closeSidebar: 'Sidebar schließen',
      support: 'Support & Anfragen',
      demoBanner: 'Demo-System — alle Daten sind erfunden, es wird nichts versendet',
    },
  },
  es: {
    nav: {
      dashboard: 'Panel',
      calendar: 'Calendario',
      appointments: 'Citas',
      reminders: 'Recordatorios',
      recalls: 'Recalls',
      patients: 'Pacientes',
      intake: 'Cuestionarios',
      invoices: 'Facturas',
      reports: 'Análisis',
      inbox: 'Bandeja de entrada',
      smartai: 'SmartAI',
      eventLog: 'Registro de eventos',
      settings: 'Ajustes',
      help: 'Ayuda',
      logout: 'Cerrar sesión',
      openSidebar: 'Abrir menú lateral',
      closeSidebar: 'Cerrar menú lateral',
      support: 'Soporte y consultas',
      demoBanner: 'Sistema de demostración — todos los datos son ficticios y no se envía nada',
    },
  },
};
